import { KeyboardDateTimePicker } from '@material-ui/pickers';
import { Form } from '@unform/web';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  @media (max-width: 768px) {
    width: 100%;
  }

  > .MuiFormControl-root {
    margin-bottom: 2rem;
  }

  p.MuiFormHelperText-root.Mui-error {
    margin-top: 0 !important;
  }
`;

export const DatePickerWrapper = styled(Form)`
  display: grid;
  grid-auto-flow: row;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 0.5rem;

  @media (max-width: 520px) {
    grid-template-columns: 1fr;
  }
`;

export const DatePicker = styled(KeyboardDateTimePicker)`
  width: 100%;
`;
